import { CookieCategory, localStore } from '@moonpig/web-core-browser-storage'

export type LastLoginMethod = 'email' | 'google' | 'apple'

export type LastLoginLocalStorage = {
  method?: LastLoginMethod
  hashedEmail?: string
}

export type LastLoginCookieData = {
  email: string
  method: LastLoginMethod
}

const LOCAL_STORAGE_KEY = 'mnpg_last_login' as const

export const getLastLoginLocalStorage = (): LastLoginLocalStorage | null => {
  const stored = localStore.tryGetItem(LOCAL_STORAGE_KEY)
  if (!stored) {
    return null
  }

  try {
    return JSON.parse(stored) as LastLoginLocalStorage
  } catch {
    return null
  }
}

export const setLastLoginMethod = (method: LastLoginMethod): void => {
  const existing = getLastLoginLocalStorage() || {}
  localStore.trySetItem(
    LOCAL_STORAGE_KEY,
    JSON.stringify({ ...existing, method }),
    CookieCategory.STRICTLY_NECESSARY,
  )
}

export const updateLastLoginLocalStorage = (
  method: LastLoginMethod,
  hashedEmail: string,
): void => {
  localStore.trySetItem(
    LOCAL_STORAGE_KEY,
    JSON.stringify({ method, hashedEmail }),
    CookieCategory.STRICTLY_NECESSARY,
  )
}

export const clearLastLoginLocalStorage = (): void => {
  localStore.tryRemoveItem(LOCAL_STORAGE_KEY)
}
